// /**
//  * Formats distance in meters to human-readable string
//  * @param meters - Distance in meters
//  * @returns Formatted string (e.g., "250 m" or "1.2 km")
//  */
// export const formatDistance = (meters: number): string => {
//   if (meters < 1000) {
//     return `${Math.round(meters)} m`;
//   }
//   return `${(meters / 1000).toFixed(1)} km`;
// };

/**
 * Formats duration in seconds to human-readable string
 * @param seconds - Duration in seconds
 * @returns Formatted string (e.g., "3 min")
 */
export const formatDuration = (seconds: number): string => {
  const minutes = Math.round(seconds / 60);
  if (minutes < 1) {
    return "< 1 min";
  }
  return `${minutes} min`;
};
